/**
 * Filter and sort schools based on preferences and AI recommendations
 */
export function filterAndSortSchools(schools, category, schoolPreferences, recommendedSchools) {
  if (!schools) return [];

  // Filter out dismissed schools
  const filteredSchools = schools.filter(school => {
    const preference = schoolPreferences[school.id];
    return preference !== 'dismissed';
  });

  // Sort: loved schools first, then AI recommended, then the rest
  return filteredSchools.sort((a, b) => {
    const prefA = schoolPreferences[a.id];
    const prefB = schoolPreferences[b.id];
    const recommendedA = recommendedSchools[category]?.includes(a.id);
    const recommendedB = recommendedSchools[category]?.includes(b.id);

    // Loved schools always first
    if (prefA === 'loved' && prefB !== 'loved') return -1;
    if (prefA !== 'loved' && prefB === 'loved') return 1;

    // Among non-loved schools, recommended schools come first
    if (prefA !== 'loved' && prefB !== 'loved') {
      if (recommendedA && !recommendedB) return -1;
      if (!recommendedA && recommendedB) return 1;
    }

    return 0; // Keep original order for same preference and recommendation status
  });
}

/**
 * Render school link (PrepScholar or school website)
 */
export function renderSchoolLink(school) {
  const linkUrl = school.prepscholar_url || school.url;
  const linkText = school.prepscholar_url ? 'More Information →' : 'Visit Website →';

  if (!linkUrl) return null;

  return (
    <a href={linkUrl} target="_blank" rel="noopener noreferrer" className="school-link">
      {linkText}
    </a>
  );
}

/**
 * Scroll to a section on the page
 */
export function scrollToSection(sectionId) {
  const element = document.getElementById(sectionId);
  if (element) {
    element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

/**
 * Grade labels mapping
 */
export const gradeLabels = {
  'middle-school': 'Middle School (Class of 2030+)',
  'freshman': 'Freshman (Class of 2029)',
  'sophomore': 'Sophomore (Class of 2028)',
  'junior': 'Junior (Class of 2027)',
  'senior': 'Senior (Class of 2026)'
};